import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { Link2 } from "lucide-react";
import RayaField from "../../elements/fields/RayaField";
import LoadingButton from "../../elements/LoadingButton";
import SubTitle from "../../elements/SubTitle";

const GoogleMapsLinkField = ({ value, onChange, onSync, loading }) => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <SubTitle align="left">{t("googleMapsLink")}</SubTitle>
            </Grid>
            <Grid size={12}>
                <RayaField
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={t("googleMapsLinkPlaceholder")}
                    helperText={t("googleMapsLinkHelp")}
                />
            </Grid>
            <Grid size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    startIcon={<Link2 className="lucide-icon" />}
                    onClick={onSync}
                    loading={loading}
                    disabled={!value?.trim()}
                >
                    {t("syncFromGoogleMapsLink")}
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

export default GoogleMapsLinkField;
